import React from 'react'
import { ArrowDropDown } from '@mui/icons-material'
import { Typography, Paper } from '@mui/material'
import styles from './SelectButton.module.scss'

export default function SelectButton({onClick, value, name, label, elevation=1, extraStyles={label: [], button: [], arrow: []}}) {

    const inputLabel = (
        <div>
            <p>{value}</p>
            <span className={extraStyles.arrow?.join(' ')}><ArrowDropDown/></span>
        </div>
    )

    return (
        <div className={styles['container']}>
            <Typography variant='body2' className={extraStyles.label?.join(' ')}>{label}</Typography>
            <Paper elevation={elevation}>
                <button className={[styles['btn'], ...extraStyles.button].join(' ')} onClick={onClick} name={name}>
                    {inputLabel}
                </button>
            </Paper>
        </div>
    )
}